export const dropdownFields = {
  indicator: [
    { key: "DPMSJ", value: "Transaction with Entity/Companies" },
    { key: "DPMSI", value: "Transaction with Resident Individuals" },
    { key: "DPMSN", value: "Transaction with Non Resident Individuals" },
  ],
  director_issue_country: [],
  incorporation_country_code: [
    { key: "AD", value: "ANDORRA" },
    { key: "AE", value: "UNITED ARAB EMIRATES" },
    { key: "AF", value: "AFGHANISTAN" },
    { key: "AG", value: "ANTIGUA AND BARBUDA" },
    { key: "AI", value: "ANGUILLA" },
    { key: "AL", value: "ALBANIA" },
    { key: "AM", value: "ARMENIA" },
    { key: "AN", value: "NETHERLANDS ANTILLES" },
    { key: "AO", value: "ANGOLA" },
    { key: "AQ", value: "ANTARCTICA" },
    { key: "AR", value: "ARGENTINA" },
    { key: "AS", value: "AMERICAN SAMOA" },
    { key: "AT", value: "AUSTRIA" },
    { key: "AU", value: "AUSTRALIA" },
    { key: "AW", value: "ARUBA" },
    { key: "AX", value: "ÅLAND ISLANDS" },
    { key: "AZ", value: "AZERBAIJAN" },
    { key: "BA", value: "BOSNIA AND HERZEGOVINA" },
    { key: "BB", value: "BARBADOS" },
    { key: "BD", value: "BANGLADESH" },
    { key: "BE", value: "BELGIUM" },
    { key: "BF", value: "BURKINA FASO" },
    { key: "BG", value: "BULGARIA" },
    { key: "BH", value: "BAHRAIN" },
    { key: "BI", value: "BURUNDI" },
    { key: "BJ", value: "BENIN" },
    { key: "BM", value: "BERMUDA" },
    { key: "BN", value: "BRUNEI DARUSSALAM" },
    { key: "BO", value: "BOLIVIA" },
    { key: "BR", value: "BRAZIL" },
    { key: "BS", value: "BAHAMAS" },
    { key: "BT", value: "BHUTAN" },
    { key: "BU", value: "BURMA" },
    { key: "BV", value: "BOUVET ISLAND" },
    { key: "BW", value: "BOTSWANA" },
    { key: "BY", value: "BELARUS" },
    { key: "BZ", value: "BELIZE" },
    { key: "CA", value: "CANADA" },
    { key: "CC", value: "COCOS (KEELING) ISLANDS" },
    { key: "CD", value: "CONGO, THE DEMOCRATIC REPUBLIC OF THE" },
    { key: "CF", value: "CENTRAL AFRICAN REPUBLIC" },
    { key: "CG", value: "CONGO" },
    { key: "CH", value: "SWITZERLAND" },
    { key: "CI", value: "COTE D'IVOIRE" },
    { key: "CK", value: "COOK ISLANDS" },
    { key: "CL", value: "CHILE" },
    { key: "CM", value: "CAMEROON" },
    { key: "CN", value: "CHINA" },
    { key: "CO", value: "COLOMBIA" },
    { key: "CR", value: "COSTA RICA" },
    { key: "CS", value: "SERBIA AND MONTENEGRO" },
    { key: "CU", value: "CUBA" },
    { key: "CV", value: "CAPE VERDE" },
    { key: "CX", value: "CHRISTMAS ISLAND" },
    { key: "CY", value: "CYPRUS" },
    { key: "CZ", value: "CZECH REPUBLIC" },
    { key: "DE", value: "GERMANY" },
    { key: "DJ", value: "DJIBOUTI" },
    { key: "DK", value: "DENMARK" },
    { key: "DM", value: "DOMINICA" },
    { key: "DO", value: "DOMINICAN REPUBLIC" },
    { key: "DZ", value: "ALGERIA" },
    { key: "EC", value: "ECUADOR" },
    { key: "EE", value: "ESTONIA" },
    { key: "EG", value: "EGYPT" },
    { key: "EH", value: "WESTERN SAHARA" },
    { key: "ER", value: "ERITREA" },
    { key: "ES", value: "SPAIN" },
    { key: "ET", value: "ETHIOPIA" },
    { key: "FI", value: "FINLAND" },
    { key: "FJ", value: "FIJI" },
    { key: "FK", value: "FALKLAND ISLANDS (MALVINAS)" },
    { key: "FM", value: "MICRONESIA, FEDERATED STATES OF" },
    { key: "FO", value: "FAROE ISLANDS" },
    { key: "FR", value: "FRANCE" },
    { key: "GA", value: "GABON" },
    { key: "GB", value: "UNITED KINGDOM" },
    { key: "GD", value: "GRENADA" },
    { key: "GE", value: "GEORGIA" },
    { key: "GF", value: "FRENCH GUIANA" },
    { key: "GG", value: "GUERNSEY" },
    { key: "GH", value: "GHANA" },
    { key: "GI", value: "GIBRALTAR" },
    { key: "GL", value: "GREENLAND" },
    { key: "GM", value: "GAMBIA" },
    { key: "GN", value: "GUINEA" },
    { key: "GP", value: "GUADELOUPE" },
    { key: "GQ", value: "EQUATORIAL GUINEA" },
    { key: "GR", value: "GREECE" },
    { key: "GS", value: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS" },
    { key: "GT", value: "GUATEMALA" },
    { key: "GU", value: "GUAM" },
    { key: "GW", value: "GUINEA-BISSAU" },
    { key: "GY", value: "GUYANA" },
    { key: "HK", value: "HONG KONG" },
    { key: "HM", value: "HEARD ISLAND AND MCDONALD ISLANDS" },
    { key: "HN", value: "HONDURAS" },
    { key: "HR", value: "CROATIA" },
    { key: "HT", value: "HAITI" },
    { key: "HU", value: "HUNGARY" },
    { key: "ID", value: "INDONESIA" },
    { key: "IE", value: "IRELAND" },
    { key: "IL", value: "ISRAEL" },
    { key: "IM", value: "ISLE OF MAN" },
    { key: "IN", value: "INDIA" },
    { key: "IO", value: "BRITISH INDIAN OCEAN TERRITORY" },
    { key: "IQ", value: "IRAQ" },
    { key: "IR", value: "IRAN, ISLAMIC REPUBLIC OF" },
    { key: "IS", value: "ICELAND" },
    { key: "IT", value: "ITALY" },
    { key: "JE", value: "JERSEY" },
    { key: "JM", value: "JAMAICA" },
    { key: "JO", value: "JORDAN" },
    { key: "JP", value: "JAPAN" },
    { key: "KE", value: "KENYA" },
    { key: "KG", value: "KYRGYZSTAN" },
    { key: "KH", value: "CAMBODIA" },
    { key: "KI", value: "KIRIBATI" },
    { key: "KM", value: "COMOROS" },
    { key: "KN", value: "SAINT KITTS AND NEVIS" },
    { key: "KP", value: "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF" },
    { key: "KR", value: "KOREA, REPUBLIC OF" },
    { key: "KW", value: "KUWAIT" },
    { key: "KY", value: "CAYMAN ISLANDS" },
    { key: "KZ", value: "KAZAKHSTAN" },
    { key: "LA", value: "LAO PEOPLE'S DEMOCRATIC REPUBLIC" },
    { key: "LB", value: "LEBANON" },
    { key: "LC", value: "SAINT LUCIA" },
    { key: "LI", value: "LIECHTENSTEIN" },
    { key: "LK", value: "SRI LANKA" },
    { key: "LR", value: "LIBERIA" },
    { key: "LS", value: "LESOTHO" },
    { key: "LT", value: "LITHUANIA" },
    { key: "LU", value: "LUXEMBOURG" },
    { key: "LV", value: "LATVIA" },
    { key: "LY", value: "LIBYAN ARAB JAMAHIRIYA" },
    { key: "MA", value: "MOROCCO" },
    { key: "MC", value: "MONACO" },
    { key: "MD", value: "MOLDOVA, REPUBLIC OF" },
    { key: "ME", value: "MONTENEGRO" },
    { key: "MG", value: "MADAGASCAR" },
    { key: "MH", value: "MARSHALL ISLANDS" },
    { key: "MK", value: "MACEDONIA" },
    { key: "ML", value: "MALI" },
    { key: "MM", value: "MYANMAR" },
    { key: "MN", value: "MONGOLIA" },
    { key: "MO", value: "MACAO" },
    { key: "MP", value: "NORTHERN MARIANA ISLANDS" },
    { key: "MQ", value: "MARTINIQUE" },
    { key: "MR", value: "MAURITANIA" },
    { key: "MS", value: "MONTSERRAT" },
    { key: "MT", value: "MALTA" },
    { key: "MU", value: "MAURITIUS" },
    { key: "MV", value: "MALDIVES" },
    { key: "MW", value: "MALAWI" },
    { key: "MX", value: "MEXICO" },
    { key: "MY", value: "MALAYSIA" },
    { key: "MZ", value: "MOZAMBIQUE" },
    { key: "NA", value: "NAMIBIA" },
    { key: "NC", value: "NEW CALEDONIA" },
    { key: "NE", value: "NIGER" },
    { key: "NF", value: "NORFOLK ISLAND" },
    { key: "NG", value: "NIGERIA" },
    { key: "NI", value: "NICARAGUA" },
    { key: "NL", value: "NETHERLANDS" },
    { key: "NO", value: "NORWAY" },
    { key: "NP", value: "NEPAL" },
    { key: "NR", value: "NAURU" },
    { key: "NU", value: "NIUE" },
    { key: "NZ", value: "NEW ZEALAND" },
    { key: "OM", value: "OMAN" },
    { key: "PA", value: "PANAMA" },
    { key: "PE", value: "PERU" },
    { key: "PF", value: "FRENCH POLYNESIA" },
    { key: "PG", value: "PAPUA NEW GUINEA" },
    { key: "PH", value: "PHILIPPINES" },
    { key: "PK", value: "PAKISTAN" },
    { key: "PL", value: "POLAND" },
    { key: "PM", value: "SAINT PIERRE AND MIQUELON" },
    { key: "PN", value: "PITCAIRN" },
    { key: "PR", value: "PUERTO RICO" },
    { key: "PS", value: "PALESTINIAN TERRITORY, OCCUPIED" },
    { key: "PT", value: "PORTUGAL" },
    { key: "PW", value: "PALAU" },
    { key: "PY", value: "PARAGUAY" },
    { key: "QA", value: "QATAR" },
    { key: "RE", value: "REUNION" },
    { key: "RO", value: "ROMANIA" },
    { key: "RS", value: "SERBIA" },
    { key: "RU", value: "RUSSIAN FEDERATION" },
    { key: "RW", value: "RWANDA" },
    { key: "SA", value: "SAUDI ARABIA" },
    { key: "SB", value: "SOLOMON ISLANDS" },
    { key: "SC", value: "SEYCHELLES" },
    { key: "SD", value: "SUDAN" },
    { key: "SE", value: "SWEDEN" },
    { key: "SG", value: "SINGAPORE" },
    { key: "SH", value: "SAINT HELENA" },
    { key: "SI", value: "SLOVENIA" },
    { key: "SJ", value: "SVALBARD AND JAN MAYEN" },
    { key: "SK", value: "SLOVAKIA" },
    { key: "SL", value: "SIERRA LEONE" },
    { key: "SM", value: "SAN MARINO" },
    { key: "SN", value: "SENEGAL" },
    { key: "SO", value: "SOMALIA" },
    { key: "SR", value: "SURINAME" },
    { key: "ST", value: "SAO TOME AND PRINCIPE" },
    { key: "SV", value: "EL SALVADOR" },
    { key: "SY", value: "SYRIAN ARAB REPUBLIC" },
    { key: "SZ", value: "SWAZILAND" },
    { key: "TC", value: "TURKS AND CAICOS ISLANDS" },
    { key: "TD", value: "CHAD" },
    { key: "TF", value: "FRENCH SOUTHERN TERRITORIES" },
    { key: "TG", value: "TOGO" },
    { key: "TH", value: "THAILAND" },
    { key: "TJ", value: "TAJIKISTAN" },
    { key: "TK", value: "TOKELAU" },
    { key: "TL", value: "TIMOR-LESTE" },
    { key: "TM", value: "TURKMENISTAN" },
    { key: "TN", value: "TUNISIA" },
    { key: "TO", value: "TONGA" },
    { key: "TR", value: "TURKEY" },
    { key: "TT", value: "TRINIDAD AND TOBAGO" },
    { key: "TV", value: "TUVALU" },
    { key: "TW", value: "TAIWAN, PROVINCE OF CHINA" },
    { key: "TZ", value: "TANZANIA, UNITED REPUBLIC OF" },
    { key: "UA", value: "UKRAINE" },
    { key: "UG", value: "UGANDA" },
    { key: "UM", value: "UNITED STATES MINOR OUTLYING ISLANDS" },
    { key: "US", value: "UNITED STATES" },
    { key: "UY", value: "URUGUAY" },
    { key: "UZ", value: "UZBEKISTAN" },
    { key: "VA", value: "HOLY SEE (VATICAN CITY STATE)" },
    { key: "VC", value: "SAINT VINCENT AND THE GRENADINES" },
    { key: "VE", value: "VENEZUELA" },
    { key: "VG", value: "VIRGIN ISLANDS, BRITISH" },
    { key: "VI", value: "VIRGIN ISLANDS, U.S." },
    { key: "VN", value: "VIET NAM" },
    { key: "VU", value: "VANUATU" },
    { key: "WF", value: "WALLIS AND FUTUNA" },
    { key: "WS", value: "SAMOA" },
    { key: "YE", value: "YEMEN" },
    { key: "YT", value: "MAYOTTE" },
    { key: "YU", value: "YUGOSLAVIA" },
    { key: "ZA", value: "SOUTH AFRICA" },
    { key: "ZM", value: "ZAMBIA" },
    { key: "ZR", value: "ZAIRE" },
    { key: "ZW", value: "ZIMBABWE" },
  ],
  nationality1: [],
  director_identification_type: [
    { key: "PP", value: "Passport" },
    { key: "EID", value: "Emirates ID" },
  ],
  director_role: [
    { key: "ATR", value: "Authorized Signatory" },
    { key: "MGR", value: "Manager" },
    { key: "PRTNR", value: "Partner" },
    { key: "SHRHL", value: "Share Holder" },
    { key: "UBO", value: "Ultimate Beneficial Owner" },
  ],
  item_type: [
    { key: "GOLD", value: "Gold" },
    { key: "DIMND", value: "Diamond" },
    { key: "JEWEL", value: "Jewellery" },
    { key: "GEM", value: "Gem Stones" },
  ],
  currency_code: [
    { key: "ADP", value: "Andorran Peseta (no longer in use)" },
    { key: "AED", value: "United Arab Emirates Dirham" },
    { key: "AFA", value: "Afghani" },
    { key: "ALL", value: "Leek" },
    { key: "AMD", value: "Dram" },
    { key: "ANG", value: "Netherlands Antilles Guilder" },
    { key: "AOK", value: "Kwanza" },
    { key: "AON", value: "New Kwanza" },
    { key: "ARA", value: "Austral" },
    { key: "ARP", value: "Argentinean Peso" },
    { key: "ARS", value: "Argentinean Nuevo Peso" },
    { key: "ATS", value: "Schilling (no longer in use)" },
    { key: "AUD", value: "Australian Dollar" },
    { key: "AWG", value: "Aruban Guilder" },
    { key: "AZM", value: "Azerbaijani Manat" },
    { key: "BAM", value: "Convertible Mark" },
    { key: "BBD", value: "Barbados Dollar" },
    { key: "BDT", value: "Taka" },
    { key: "BGL", value: "Lev" },
    { key: "BHD", value: "Bahraini Dinar" },
    { key: "BIF", value: "Burundi Franc" },
    { key: "BMD", value: "Bermudian Dollar" },
    { key: "BND", value: "Brunei Dollar" },
    { key: "BOB", value: "Boliviano" },
    { key: "BOP", value: "Bolivian Peso" },
    { key: "BRC", value: "Cruzeiro" },
    { key: "BRL", value: "Real" },
    { key: "BRR", value: "Cruzeiro Real" },
    { key: "BSD", value: "Bahamian Dollar" },
    { key: "BTN", value: "Ngultrum" },
    { key: "BUK", value: "Replaced by MMK" },
    { key: "BWP", value: "Pula" },
    { key: "BYR", value: "Belarussian Rouble" },
    { key: "BZD", value: "Belize Dollar" },
    { key: "CAD", value: "Canadian Dollar" },
    { key: "CDF", value: "Congolese Franc" },
    { key: "CDZ", value: "New Zaïre" },
    { key: "CHF", value: "Swiss Franc" },
    { key: "CLF", value: "Unidades de Fomento" },
    { key: "CLP", value: "Chilean Peso" },
    { key: "CNY", value: "Yuan Renminbi" },
    { key: "COP", value: "Colombian Peso" },
    { key: "CRC", value: "Costa Rican Colón" },
    { key: "CSK", value: "Koruna of former Czechoslovakia" },
    { key: "CUP", value: "Cuban Peso" },
    { key: "CVE", value: "Escudo Caboverdiano" },
    { key: "CYP", value: "Cypriot Pound" },
    { key: "CZK", value: "Czech Koruna" },
    { key: "DDM", value: "Former East German Mark" },
    { key: "DEM", value: "Deutsche Mark (no longer in use)" },
    { key: "DJF", value: "Djibouti Franc" },
    { key: "DKK", value: "Danish Krone" },
    { key: "DOP", value: "Dominican Republic Peso" },
    { key: "DZD", value: "Algerian Dinar" },
    { key: "ECS", value: "Sucre (no longer in use)" },
    { key: "EEK", value: "Kroon" },
    { key: "EGP", value: "Egyptian Pound" },
    { key: "ERN", value: "Eritrean Nakfa" },
    { key: "ESA", value: "Spanish Peseta, Account A (no longer in use)" },
    { key: "ESB", value: "Spanish Peseta, Account B (no longer in use)" },
    { key: "ESP", value: "Spanish Peseta (no longer in use)" },
    { key: "ETB", value: "Ethiopian Birr" },
    { key: "EUR", value: "Euro" },
    { key: "FIM", value: "Markka (no longer in use)" },
    { key: "FJD", value: "Fiji Dollar" },
    { key: "FKP", value: "Falkland Pound" },
    { key: "FRF", value: "French Franc (no longer in use)" },
    { key: "GBP", value: "Pound Sterling (United Kingdom Pound)" },
    { key: "GEL", value: "Lari" },
    { key: "GHC", value: "Cedi" },
    { key: "GIP", value: "Gibraltar Pound" },
    { key: "GMD", value: "Dalasi" },
    { key: "GNS", value: "Syli (also known as Guinea Franc)" },
    { key: "GQE", value: "Ekwele" },
    { key: "GRD", value: "Greek Drachma (no longer in use)" },
    { key: "GTQ", value: "Quetzal" },
    { key: "GWP", value: "Guinea-Bissau Peso" },
    { key: "GYD", value: "Guyana Dollar" },
    { key: "HKD", value: "Hong Kong Dollar" },
    { key: "HNL", value: "Lempira" },
    { key: "HRD", value: "Croatian Dinar" },
    { key: "HRK", value: "Croatian Kuna" },
    { key: "HTG", value: "Gourde" },
    { key: "HUF", value: "Forint" },
    { key: "IDR", value: "Rupiah" },
    { key: "IEP", value: "Punt (no longer in use)" },
    { key: "ILS", value: "Shekel" },
    { key: "INR", value: "Indian Rupee" },
    { key: "IQD", value: "Iraqi Dinar" },
    { key: "IRR", value: "Iranian Rial" },
    { key: "ISK", value: "Icelandic Króna" },
    { key: "ITL", value: "Italian Lira (no longer in use)" },
    { key: "JMD", value: "Jamaican Dollar" },
    { key: "JOD", value: "Jordanian Dinar" },
    { key: "JPY", value: "Yen" },
    { key: "KES", value: "Kenyan Shilling" },
    { key: "KGS", value: "Kyrgyzstani Som" },
    { key: "KHR", value: "Riel" },
    { key: "KMF", value: "Comorian Franc" },
    { key: "KPW", value: "Democratic People's Republic of Korean Won" },
    { key: "KRW", value: "Republic of Korean Won" },
    { key: "KWD", value: "Kuwaiti Dinar" },
    { key: "KYD", value: "Cayman Islands Dollar" },
    { key: "KZT", value: "Tenge" },
    { key: "LAK", value: "Kip" },
    { key: "LBP", value: "Lebanese Pound" },
    { key: "LKR", value: "Sri Lankan Rupee" },
    { key: "LRD", value: "Liberian Dollar" },
    { key: "LSL", value: "Loti" },
    { key: "LSM", value: "Maloti" },
    { key: "LTL", value: "Litas" },
    { key: "LUF", value: "Luxembourg Franc (no longer in use)" },
    { key: "LVL", value: "Lats" },
    { key: "LYD", value: "Libyan Dinar" },
    { key: "MAD", value: "Moroccan Dirham" },
    { key: "MDL", value: "Moldavian Leu" },
    { key: "MGF", value: "Malagasy Franc" },
    { key: "MKD", value: "Macedonian Dinar" },
    { key: "MLF", value: "Malian Franc" },
    { key: "MMK", value: "Kyat" },
    { key: "MNT", value: "Tugrik" },
    { key: "MOP", value: "Pataca" },
    { key: "MRO", value: "Ouguiya" },
    { key: "MTL", value: "Maltese Lira" },
    { key: "MTP", value: "Maltese Pound, replaced by Maltese Lira" },
    { key: "MUR", value: "Mauritius Rupee" },
    { key: "MVR", value: "Rufiyaa" },
    { key: "MWK", value: "Malawian Kwacha" },
    { key: "MXN", value: "Mexican New Peso (replacement for Mexican Peso)" },
    { key: "MXP", value: "Mexican Peso, replaced by Mexican New Peso" },
    { key: "MYR", value: "Ringgit (also known as Malaysian Dollar)" },
    { key: "MZM", value: "Metical" },
    { key: "NAD", value: "Namibian Dollar" },
    { key: "NGN", value: "Naira" },
    { key: "NIC", value: "Córdoba" },
    { key: "NLG", value: "Dutch Guilder (no longer in use)" },
    { key: "NOK", value: "Norwegian Krone" },
    { key: "NPR", value: "Nepalese Rupee" },
    { key: "NZD", value: "New Zealand Dollar" },
    { key: "OMR", value: "Omani Rial" },
    { key: "PAB", value: "Balboa" },
    { key: "PEI", value: "Inti" },
    { key: "PEN", value: "New Sol" },
    { key: "PES", value: "Sol (replaced by New Sol [PEN])" },
    { key: "PGK", value: "Kina" },
    { key: "PHP", value: "Philippines Peso" },
    { key: "PKR", value: "Pakistani Rupee" },
    { key: "PLN", value: "New Zloty" },
    { key: "PLZ", value: "Zloty (replaced by New Zloty [PLN])" },
    { key: "PTE", value: "Portuguese Escudo (no longer in use)" },
    { key: "PYG", value: "Guarani" },
    { key: "QAR", value: "Qatari Riyal" },
    { key: "ROL", value: "Romanian Leu" },
    { key: "RSD", value: "Serbian Dinar" },
    { key: "RUB", value: "Russian Federation Rouble (formerly RUR)" },
    { key: "RWF", value: "Rwandan Franc" },
    { key: "SAR", value: "Saudi Riyal" },
    { key: "SBD", value: "Solomon Islands Dollar" },
    { key: "SCR", value: "Seychelles Rupee" },
    { key: "SDD", value: "Sudanese Dinar" },
    { key: "SDP", value: "Sudanese Pound" },
    { key: "SEK", value: "Swedish Krona" },
    { key: "SGD", value: "Singapore Dollar" },
    { key: "SHP", value: "St Helena Pound" },
    { key: "SIT", value: "Tolar" },
    { key: "SKK", value: "Slovak Koruna" },
    { key: "SLL", value: "Leone" },
    { key: "SOS", value: "Somali Shilling" },
    { key: "SRG", value: "Surinam Guilder" },
    { key: "STD", value: "Dobra" },
    { key: "SUR", value: "Union of Soviet Socialist Republics Rouble" },
    { key: "SVC", value: "El Salvadorian Colón" },
    { key: "SYP", value: "Syrian Pound" },
    { key: "SZL", value: "Lilangeni" },
    { key: "THB", value: "Baht" },
    { key: "TJR", value: "Tajik Rouble" },
    { key: "TMM", value: "Turkmenistani Manat" },
    { key: "TND", value: "Tunisian Dinar" },
    { key: "TOP", value: "Pa'anga" },
    { key: "TPE", value: "Timorian Escudo" },
    { key: "TRL", value: "Turkish Lira" },
    { key: "TTD", value: "Trinidad and Tobago Dollar" },
    { key: "TWD", value: "Taiwan Dollar" },
    { key: "TZS", value: "Tanzanian Shilling" },
    { key: "UAH", value: "Hryvna" },
    { key: "UAK", value: "Karbovanet" },
    { key: "UGS", value: "Ugandan Shilling" },
    { key: "UKP", value: "Incorrectly used for GBP" },
    { key: "USD", value: "United States Dollar" },
    { key: "USN", value: "United States Dollar (Next day)" },
    { key: "USS", value: "United States Dollar (Same day)" },
    {
      key: "UYP",
      value: "Uruguayan Peso, replaced by Uruguayan New Peso (UYU)",
    },
    { key: "UYU", value: "Uruguayan New Peso" },
    { key: "UZS", value: "Uzbekistani Som" },
    { key: "VEB", value: "Bolivar" },
    { key: "VND", value: "Viet Nam Dông" },
    { key: "VUV", value: "Vatu" },
    { key: "WST", value: "Tala" },
    { key: "XAF", value: "Franc de la Communauté financière africaine" },
    { key: "XAU", value: "Gold" },
    { key: "XBA", value: "European Composite Unit" },
    { key: "XBB", value: "European Monetary Unit" },
    { key: "XBC", value: "European Unit of Account 9" },
    { key: "XBD", value: "European Unit of Account 17" },
    { key: "XCD", value: "East Caribbean Dollar" },
    {
      key: "XDR",
      value: "International Monetary Fund Special Drawing Rights",
    },
    {
      key: "XEU",
      value: "ECU (not an official currency, replaced by the Euro)",
    },
    { key: "XOF", value: "West African Franc" },
    { key: "XPF", value: "Franc des Comptoirs français du Pacifique" },
    { key: "YDD", value: "South Yemeni Dinar" },
    { key: "YER", value: "Yemeni Riyal" },
    { key: "YUD", value: "Yugoslavian New Dinar (no longer in use)" },
    { key: "ZAL", value: "Rand (financial)" },
    { key: "ZAR", value: "Rand" },
    { key: "ZMK", value: "Zambian Kwacha" },
    { key: "ZRZ", value: "Replaced by CDZ" },
    { key: "ZWD", value: "Zimbabwe Dollar" },
  ],
};
